<template>
    <section class="car-wash">
        <div class="inner">
            <div class="details">
                <h4 class="h6">Asemalla saatavilla myös</h4>
                <h5 class="h4">Autopesuohjelmat</h5>
                <div class="specs">
                    <h6 class="subtitle16">
                        <template v-if="carwash24h">
                            Autopesu 24h<br>
                        </template>
                        <template v-if="carwashHeight && carwashWidth">
                            Pesukoneen korkeus {{ carwashHeight }} cm<br>
                            Pesukoneen leveys {{ carwashWidth }} cm
                        </template>
                    </h6>
                </div>
                <div class="seo-text">
                    Pesuvalikoimastamme voit valita juuri oikean pesun sinun autollesi. St1 Autopesut on suunniteltu sopivaksi erilaisille likaisuusasteille. Lisäksi pesuohjelmat räätälöidään vuodenaikojen ja niille tyypillisen lian mukaan
                </div>
                <div class="cta-button">
                    <nuxt-link
                        href="https://autopesu.st1.fi"
                        target="_blank"
                    >
                        <DSButton
                            class="ds-btn ds-btn--primary ds-btn--large"
                        >
                            Tutustu Autopesuohjelmiin
                        </DSButton>
                    </nuxt-link>
                </div>
            </div>
            <div class="car-wash-image">
                <img alt="Perfect autopesu 24h" src="/images/station-page_car-wash.png" />
            </div>
        </div>
    </section>
</template>
<script setup>
import { computed, storeToRefs } from '#imports';
import { usePageStore } from '~dsc/stores/cms/page';

defineProps({
    stations: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const { station } = storeToRefs(usePageStore());

const carwash24h = computed(() => station.value.services?.map(s => s.name).includes('perfectcarwash24hours'));

const carwashDimensions = computed(() => station.value?.carWashSize?.split('/') || []);

const carwashHeight = computed(() => carwashDimensions.value?.[0] || null);

const carwashWidth = computed(() => carwashDimensions.value?.[1] || null);
</script>
<style scoped>
.car-wash {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.car-wash .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}

.inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 3rem;
  gap: 1rem;
  align-items: center;
}
.inner .seo-text {
  margin: 1rem 0 3rem;
  max-width: 28rem;
}
@media (max-width: 767px) {
  .inner {
    grid-template-columns: 1fr;
  }
  .inner .details {
    grid-row-start: 2;
  }
  .inner .car-wash-image {
    grid-row-start: 1;
  }
}
</style>

